import React from "react";
import {Breadcrumbs} from "@mui/material";
import BaseLayout from "@/Layouts/BaseLayout";
import Link from "@/Layouts/Link";
import Picture from "@/Components/Picture";
import "@/Scss/Site/Sales/index.scss";

const Index = (props) => {
    const {h1 = '', sales = []} = props;

    return (
        <BaseLayout {...props}>
            <section className={`section`}>
                <div className={`container`}>
                    <Breadcrumbs maxItems={2} itemsAfterCollapse={2} className={`breadcrumbs`}>
                        <Link className={`breadcrumbs__link`} href={`/`}>Главная</Link>
                        <p className={`breadcrumbs__text`}>{h1}</p>
                    </Breadcrumbs>
                    <h1 className={`h1`}>{h1}</h1>
                    <div className={`sales`}>
                        {sales.length === 0 && (
                            <h2>Все акции завершены! Следите за нашими новостями!</h2>
                        )}
                        {sales.map((el) => (
                            <div key={el.id} className={`sales__item`}>
                                <Link href={`/stocks/${el.alias}`}>
                                    <div className={`sales__content`}>
                                        <div className={`sales__line`}></div>
                                        <p className={`sales__title`}>{el.name}</p>
                                    </div>
                                    <div className={`sales__image`}>
                                        <Picture src={el.img_mobile} alt={el.name} imageClassName={`increase`} />
                                    </div>
                                </Link>
                            </div>
                        ))}
                    </div>
                </div>
            </section>
        </BaseLayout>
    );
};

export default Index;
